module.exports = __webpack_public_path__ + "img/login_logo.054f6a36.png";